import {Feature, Map, View} from 'ol';
import XYZ from "ol/source/XYZ";
import {Tile, Vector as VectorLayer} from "ol/layer";
import {Vector as VectorSource} from "ol/source";
import {Icon, Style, Text, Fill, Stroke} from "ol/style";
import {defaults} from "ol/interaction";
import {fromLonLat} from "ol/proj.js";
import {Point} from "ol/geom";

export default function initOlMaps() {
  const mapElems = document.querySelectorAll('[data-map]');
  mapElems.forEach(createMap);
}

function createMap(el) {
  const iconFeature = new Feature({
    geometry: new Point(fromLonLat([el.dataset.lon, el.dataset.lat])),
  });

  // Construct vector layers.
  const markers = el.dataset.markers ? JSON.parse(el.dataset.markers) : null;
  const layers = [];
  if (markers) {
    markers.forEach(m => {
      const layer = new VectorLayer({
        source: new VectorSource({
          features: [new Feature({
            geometry: new Point(fromLonLat([m.lon, m.lat])),
          })]
        }),
        style: new Style({
          image: new Icon({
            anchor: [0.5, 0.5],
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            src: "/static/images/icons8-location-24.png"
          }),
          text: new Text({
            text: stringDivider(m.title, 32, '\n'),
            font: '13px sans-serif',
            overflow: true,
            textBaseline: 'bottom',
            offsetY: -14,
            backgroundFill: new Fill({
              color: '#fff'
            }),
            backgroundStroke: new Stroke({
              width: 1,
              color: '#757575'
            }),
            padding: [2, 8, 2, 8]
          })
        })
      });
      layers.push(layer);
    });
  }

  return new Map({
    target: el,
    // controls: [],
    layers: [
      new Tile({
        source: new XYZ({
          url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }),
      }),
      new VectorLayer({
        source: new VectorSource({
          features: [iconFeature]
        }),
        style: new Style({
          image: new Icon({
            anchor: [0.5, 0.5],
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            src: "/static/images/icons8-home-address-48.png"
          }),
          text: new Text({
            text: stringDivider(el.dataset.title, 40, '\n'),
            font: '14px sans-serif',
            textBaseline: 'bottom',
            offsetY: -24,
            backgroundFill: new Fill({
              color: '#fff'
            }),
            backgroundStroke: new Stroke({
              width: 1,
              color: '#757575'
            }),
            padding: [2, 8, 2, 8]
          })
        })
      }),
      ...layers,
    ],
    view: new View({
      center: fromLonLat([parseFloat(el.dataset.lon), parseFloat(el.dataset.lat)]),
      zoom: 13
    }),
    interactions: defaults({mouseWheelZoom: false, pinchZoom: true, doubleClickZoom: true, shiftDragZoom: true}),
  });
}

// https://stackoverflow.com/questions/14484787/wrap-text-in-javascript
function stringDivider(str, width, spaceReplacer) {
  if (str.length > width) {
    let p = width;
    while (p > 0 && str[p] !== ' ' && str[p] !== '-') {
      p--;
    }
    if (p > 0) {
      let left;
      if (str.substring(p, p + 1) === '-') {
        left = str.substring(0, p + 1);
      } else {
        left = str.substring(0, p);
      }
      const right = str.substring(p + 1);
      return left + spaceReplacer + stringDivider(right, width, spaceReplacer);
    }
  }
  return str;
}
